import { Component, Input, OnInit } from '@angular/core';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';

@Component({
  selector: 'app-footer-funnels-one-step-basic',
  templateUrl: './footer-funnels-one-step-basic.component.html',
  styleUrls: ['./footer-funnels-one-step-basic.component.scss']
})
export class FooterFunnelsOneStepBasicComponent implements OnInit {
  @Input() currentYear!: number;
  @Input() brandResources!: IBrandResources;
  
  constructor() { }

  ngOnInit(): void {
  }

}
